import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "d-flex justify-content-between" };
const _hoisted_2 = { class: "d-flex" };
const _hoisted_3 = ["disabled"];
const _hoisted_4 = ["disabled"];
const _hoisted_5 = {
    class: "list-filter",
    style: { "height": "300px", "overflow-x": "auto", "border": "1px solid black", "background-color": "whitesmoke" }
};
const _hoisted_6 = { class: "list-options" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { style: { "font-weight": "700", "font-size": "16px" } };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_select = _resolveComponent("b-form-select");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createBlock(_component_b_modal, {
        class: "modal-form-lg",
        modelValue: _ctx.show,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.show) = $event)),
        title: _ctx.modalTitle,
        "header-bg-variant": "normal",
        size: "lg"
    }, {
        footer: _withCtx(() => [
            _createVNode(_component_b_button, {
                type: "button",
                variant: "secondary",
                onClick: _ctx.cancel
            }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                        _createTextVNode("Cancel", -1 /* CACHED */)
                    ]))]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]),
            _cache[20] || (_cache[20] = _createTextVNode()),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.submit,
                disabled: _ctx.selectedUserIds.length === 0
            }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode("Submit", -1 /* CACHED */)
                    ]))]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick", "disabled"])
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", null, [
                _cache[6] || (_cache[6] = _createElementVNode("label", null, "Company", -1 /* CACHED */)),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedCompany,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompany) = $event)),
                    options: _ctx.companies,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "Select company",
                    class: "multiselect-small mb-3"
                }, {
                    noResult: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ]),
            _cache[21] || (_cache[21] = _createTextVNode()),
            _createElementVNode("div", null, [
                _cache[8] || (_cache[8] = _createElementVNode("label", null, "Action", -1 /* CACHED */)),
                _cache[9] || (_cache[9] = _createTextVNode()),
                _createVNode(_component_b_form_select, {
                    modelValue: _ctx.selectedAction,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedAction) = $event)),
                    options: _ctx.actionOptions,
                    class: "mb-3"
                }, null, 8 /* PROPS */, ["modelValue", "options"])
            ]),
            _cache[22] || (_cache[22] = _createTextVNode()),
            _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", null, "Users", -1 /* CACHED */)),
                    _cache[13] || (_cache[13] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("label", null, "Selected: " + _toDisplayString(_ctx.selectedUserIds.length), 1 /* TEXT */),
                        _cache[10] || (_cache[10] = _createTextVNode()),
                        _withDirectives(_createElementVNode("input", {
                            class: "form-check-input ms-3",
                            style: { "margin-top": "2px" },
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.showOnlySelected) = $event)),
                            disabled: _ctx.selectedUserIds.length === 0
                        }, null, 8 /* PROPS */, _hoisted_3), [
                            [_vModelCheckbox, _ctx.showOnlySelected]
                        ]),
                        _cache[11] || (_cache[11] = _createTextVNode()),
                        _createElementVNode("label", {
                            class: "form-check-label",
                            disabled: _ctx.selectedUserIds.length === 0
                        }, " Show only selected", 8 /* PROPS */, _hoisted_4)
                    ])
                ]),
                _cache[16] || (_cache[16] = _createTextVNode()),
                _createVNode(_component_b_form_input, {
                    modelValue: _ctx.usersFilter,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.usersFilter) = $event)),
                    modelModifiers: { trim: true },
                    placeholder: "Search for..."
                }, null, 8 /* PROPS */, ["modelValue"]),
                _cache[17] || (_cache[17] = _createTextVNode()),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (user) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: user.userId,
                                class: _normalizeClass(['list-option', _ctx.isUserSelected(user) ? 'selected-option' : '']),
                                onClick: ($event) => (_ctx.toggleUser(user)),
                                style: { "text-align": "left", "padding": "5px" }
                            }, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1 /* TEXT */),
                                    _cache[14] || (_cache[14] = _createTextVNode()),
                                    _createElementVNode("span", null, " - " + _toDisplayString(user.userName), 1 /* TEXT */),
                                    _cache[15] || (_cache[15] = _createTextVNode()),
                                    _createElementVNode("span", null, " (" + _toDisplayString(user.emailAddress) + ")", 1 /* TEXT */)
                                ])
                            ], 10 /* CLASS, PROPS */, _hoisted_7));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ]),
            _cache[23] || (_cache[23] = _createTextVNode())
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "title"]));
}
